import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FooterLinkViewerModels } from '@medsurf/flat-models';
import { AppSharedFacade, NodeSharedFacade } from '@medsurf/flat-facades';

@Component({
    selector: 'medsurf-elearnings',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './elearnings.component.html',
    styleUrls: ['./elearnings.component.scss'],
    standalone: false
})
export class ElearningsComponent {
  /**
   * TODO move to route data
   * Members
   */
  public footerLinks: FooterLinkViewerModels.FooterLink[] = [
    {title: 'DATENSCHUTZERKLÄRUNG', url: 'privacy'},
    {title: 'IMPRESSUM', url: 'impressum'}
  ];

  /**
   * Constructor
   *
   * @param appSharedFacade
   * @param nodeSharedFacade
   */
  public constructor(public appSharedFacade: AppSharedFacade,
                     public nodeSharedFacade: NodeSharedFacade) {
  }
}
